import React, { useState } from "react";
import { useSelector } from "react-redux";
import { deleteNulls, PeriodTypeId } from "../../../helpers/helpers";
import { RUSSIAN_LOCALE } from "../../../helpers/const";
import { CalcRangeSelector } from "../CalcRangeSelector";
import { selectLoan } from "@/store/selectors";

export const LoanSelector = ({ selected, items = [], onSelect }) => {
  const amounts = useSelector(selectLoan);
  const [value, setValue] = useState(selected);
  return (
    <>
      <li className="item">
        <ul className="form-list-in">
          <li>
            <div className="label">Сумма займа</div>
            <div className="rub">
              {value && deleteNulls(String(value.number))} ₽
            </div>
          </li>
          <li>
            <div className="label">
              {amounts.periodTypeId === PeriodTypeId.days
                ? "Сумма к возврату:"
                : "Платеж раз в 2 недели:"}
            </div>
            <div className="rub">
              {`${(
                amounts.paymentAmount || amounts.refundAmount
              )?.toLocaleString(RUSSIAN_LOCALE)} ₽`}
            </div>
          </li>
        </ul>
      </li>
      <li className="item item--calculator-mobile progressbar">
        <CalcRangeSelector
          selected={selected}
          items={items}
          onChange={(item) => setValue(item)}
          onSelect={onSelect}
        />
      </li>
    </>
  );
};
